import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

/* ------FOLDERS CRUD------ */
export async function getOrgFolders() {
  return fetcher.get({
    path: '/folders/organization',
  });
}
export async function createFolder({ name }) {
  return fetcher.post({
    path: '/folders',
    body: { name },
  });
}

export async function updateFolder(id, updateData) {
  return fetcher.put({
    path: `/folders/${id}`,
    body: updateData,
  });
}

export async function deleteFolder(id) {
  return fetcher.delete({
    path: `/folders/${id}`,
    body: {},
  });
}
